import { FieldEdition, useTruncatedTextTooltip } from 'sonata-react-components';

type Props = {
  className?: string;
  iconPosition?: 'left' | 'right';
  notEditable?: boolean;
  onTextChange?: (newText: string) => void;
  rowId: string;
  showSmart?: boolean;
  text: string;
};

function Title({
  className,
  iconPosition = 'left',
  notEditable,
  onTextChange,
  rowId,
  showSmart,
  text
}: Readonly<Props>) {
  const { tooltip, triggerProps } = useTruncatedTextTooltip(text);

  return (
    <div className={`mapListTitle ${className || ''}`} {...triggerProps}>
      {!notEditable ? (
        <FieldEdition
          iconPosition={iconPosition}
          id={`mapListTitle-fieldEdition-${rowId}`}
          onChange={value => onTextChange?.(value)}
          value={text}
        >
          {text}
        </FieldEdition>
      ) : (
        text
      )}
      {showSmart && <span className="mapListTitle__point" />}
      {tooltip}
    </div>
  );
}

export default Title;
